// Variant configuration for A/B hero.
// URL param: /?v=muscle  → muscle-growth pitch
//            /?v=weight  → weight-gain pitch (default)

export const VARIANTS = {
  weight: {
    id: "weight",
    badge: "Ayurvedic · Healthy Weight Gain",
    headlineA: "Gain Healthy",
    headlineB: "Weight",
    headlineC: "Naturally.",
    headlineD: "",
    subheading:
      "100% Ayurvedic formula that supports healthy weight gain, improves appetite, digestion, stamina and strength when combined with a balanced diet.",
    ctaLabel: "Buy Now — ₹749",
  },
  muscle: {
    id: "muscle",
    badge: "Ayurvedic · Muscle Growth",
    headlineA: "Build Real",
    headlineB: "Muscle.",
    headlineC: "Naturally.",
    headlineD: "No Steroids.",
    subheading:
      "Ashwagandha-powered Ayurvedic formula that supports lean muscle development, faster recovery, and raw strength — the way our ancestors intended.",
    ctaLabel: "Start Building — ₹749",
  },
};

export function getVariant() {
  if (typeof window === "undefined") return VARIANTS.weight;
  const p = new URLSearchParams(window.location.search).get("v");
  if (p === "muscle") return VARIANTS.muscle;
  return VARIANTS.weight;
}
